import * as a from './address'
import * as c from './constants'
import * as p from './payment'
import s from './storage'
import * as u from './util'

export const constants = c
export const util = u
export const storage = s
export const payment = p
export const address = a


// window.addEventListener('unload', () => {
//   storage.B3IsInitDefaultAddresses.removeValue()
// })
